import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
export function GoogleIcon(t0) {
  const $ = _c(14);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("size-5", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <defs><path id="a" d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" /></defs>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <clipPath id="b"><use xlinkHref="#a" overflow="visible" /></clipPath>;
    t4 = <path clipPath="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z" />;
    t5 = <path clipPath="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" />;
    t6 = <path clipPath="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" />;
    t7 = <path clipPath="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" />;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] !== props || $[12] !== t1) {
    t8 = <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" className={t1} {...props}>{t2}{t3}{t4}{t5}{t6}{t7}</svg>;
    $[11] = props;
    $[12] = t1;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}